{
  "version": 1,
  "asset_id": "fdbf2aaa-9b24-4c78-8042-7da8651276a5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/fdbf2aaa-9b24-4c78-8042-7da8651276a5/white-metal-roof-crystal-river-fl-1024.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/fdbf2aaa-9b24-4c78-8042-7da8651276a5/white-metal-roof-crystal-river-fl-1024.avif",
  "original_filename": "white-metal-roof-crystal-river-fl-1024.avif",
  "size": 39786,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:36:02Z"
}
